import { colors } from "@/theme/colors";
import { IllustrationSvg } from "./IllustrationSvg";

/**
 * Flat illustration for the Website offering: a browser window with a
 * sidebar, content lines, and a small bar chart — a working product, live.
 */
export function WebIllustration() {
  return (
    <IllustrationSvg>
      {/* Browser window */}
      <rect
        x="20"
        y="10"
        width="180"
        height="110"
        rx="10"
        fill={colors.paper}
        stroke={colors.divider}
        strokeWidth="2"
      />
      {/* Title bar */}
      <path
        d="M20 20a10 10 0 0 1 10-10h160a10 10 0 0 1 10 10v12H20z"
        fill={colors.tintDeep}
      />
      <circle cx="34" cy="21" r="3.5" fill={colors.secondary} />
      <circle cx="46" cy="21" r="3.5" fill={colors.warning} />
      <circle cx="58" cy="21" r="3.5" fill={colors.success} />
      <rect x="80" y="16" width="100" height="10" rx="5" fill={colors.paper} />
      {/* Sidebar */}
      <rect
        x="30"
        y="42"
        width="44"
        height="68"
        rx="6"
        fill={colors.tintDeep}
      />
      <rect
        x="36"
        y="50"
        width="32"
        height="6"
        rx="3"
        fill={colors.primary}
        opacity="0.55"
      />
      <rect
        x="36"
        y="62"
        width="26"
        height="6"
        rx="3"
        fill={colors.primary}
        opacity="0.3"
      />
      <rect
        x="36"
        y="74"
        width="30"
        height="6"
        rx="3"
        fill={colors.primary}
        opacity="0.3"
      />
      {/* Content lines */}
      <rect
        x="84"
        y="44"
        width="76"
        height="8"
        rx="4"
        fill={colors.textPrimary}
        opacity="0.8"
      />
      <rect x="84" y="58" width="106" height="6" rx="3" fill={colors.divider} />
      <rect x="84" y="69" width="92" height="6" rx="3" fill={colors.divider} />
      {/* Bar chart */}
      <rect
        x="86"
        y="96"
        width="12"
        height="14"
        rx="2"
        fill={colors.primary}
        opacity="0.45"
      />
      <rect
        x="104"
        y="88"
        width="12"
        height="22"
        rx="2"
        fill={colors.primary}
        opacity="0.7"
      />
      <rect
        x="122"
        y="92"
        width="12"
        height="18"
        rx="2"
        fill={colors.secondary}
        opacity="0.8"
      />
      <rect
        x="140"
        y="82"
        width="12"
        height="28"
        rx="2"
        fill={colors.primary}
      />
      {/* Live badge */}
      <rect
        x="158"
        y="84"
        width="34"
        height="16"
        rx="8"
        fill={colors.paper}
      />
      <circle cx="167" cy="92" r="3" fill={colors.success} />
      <rect
        x="173"
        y="89.5"
        width="14"
        height="5"
        rx="2.5"
        fill={colors.success}
        opacity="0.6"
      />
    </IllustrationSvg>
  );
}
